import Reveal from "@/components/base/Reveal";
import { characters } from "@/mocks/drama";

const toneMap: Record<string, { bubble: string; role: string }> = {
  primary: { bubble: "bg-primary-500 text-background-50", role: "text-primary-700" },
  secondary: { bubble: "bg-secondary-500 text-background-50", role: "text-secondary-700" },
  accent: { bubble: "bg-accent-500 text-foreground-950", role: "text-accent-700" },
};

export default function Characters() {
  return (
    <section id="characters" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="flex items-center justify-center gap-2 font-label text-sm tracking-[0.3em] text-primary-600">
              <i className="ri-team-line" />
              人 物 线 索
            </p>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              六个关键人物，六种欲望
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              理解每个人想要什么、又怕失去什么，就能看懂他们的选择为什么既合理又危险。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {characters.map((person, idx) => {
            const tone = toneMap[person.color] ?? toneMap.primary;
            return (
              <Reveal key={person.name} delay={idx * 60}>
                <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-6 transition hover:border-primary-300">
                  <div className="flex items-center gap-4">
                    <span
                      className={`flex h-12 w-12 items-center justify-center rounded-lg text-2xl ${tone.bubble}`}
                    >
                      <i className={person.icon} />
                    </span>
                    <div>
                      <h3 className="font-heading text-lg font-bold text-foreground-950">
                        {person.name}
                      </h3>
                      <p className={`mt-0.5 text-xs font-medium ${tone.role}`}>{person.role}</p>
                    </div>
                  </div>
                  <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">
                    {person.desc}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}